// import React, { useState, useEffect } from "react";
// import { useSearchParams } from "react-router-dom";
// import axios from "axios";
// import { motion } from "framer-motion";
// import { apiurl } from "../config/config";
// import Header from "../components/header";
// import { AlertCircle } from "lucide-react"; // modern icons

// const maskEmail = (email) => {
//   if (!email) return "";
//   const [name, domain] = email.split("@");
//   return name.slice(0, 3) + "****@" + domain;
// };

// const maskPhone = (phone) => {
//   if (!phone) return "";
//   return "******" + phone.slice(-4);
// };

// const TrackingDetails = () => {
//   const [searchParams] = useSearchParams();
//   const applicationId = searchParams.get("applicationid");
//   const [application, setApplication] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     if (applicationId) {
//       fetchApplicationDetails(applicationId);
//     }
//   }, [applicationId]);

//   const fetchApplicationDetails = async (id) => {
//     try {
//       const response = await axios.get(
//         `${apiurl}/api/application/get/id/${id}`
//       );

//       if (response.data.success) {
//         setApplication(response.data.application);
//       } else {
//         setError(response.data.message || "Candidate not found");
//       }
//     } catch (err) {
//       setError("Failed to fetch application details. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   if (loading) {
//     return (
//       <div className="min-h-screen flex items-center justify-center bg-gray-100 text-gray-700 text-lg">
//         Loading...
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 px-6 py-10">
//         <motion.div
//           initial={{ scale: 0.8, opacity: 0 }}
//           animate={{ scale: 1, opacity: 1 }}
//           transition={{ duration: 0.4 }}
//           className="bg-white p-6 rounded-2xl shadow-lg w-full max-w-md text-center border border-red-200"
//         >
//           <div className="flex justify-center mb-4">
//             <div className="bg-red-100 p-4 rounded-full">
//               <AlertCircle className="w-10 h-10 text-red-500" />
//             </div>
//           </div>
//           <h2 className="text-xl font-bold text-red-600 mb-2">
//             Candidate Not Found
//           </h2>
//           <p className="text-gray-600 text-sm mb-4">
//             We couldn’t locate an application with ID:{" "}
//             <span className="font-semibold">{applicationId}</span>
//           </p>
//           <button
//             onClick={() => window.location.href = "/"}
//             className="mt-2 w-full py-2 px-4 bg-red-500 hover:bg-red-600 text-white rounded-lg font-medium transition"
//           >
//             Go Back Home
//           </button>
//         </motion.div>
//       </div>
//     );
//   }

//   return (
//     <div>
//       <Header />
//       <motion.div
//         className="min-h-screen px-3 py-6 bg-gray-50"
//         initial={{ opacity: 0, y: -20 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ duration: 0.5 }}
//       >
//         <div className="max-w-4xl mx-auto bg-white shadow-xl rounded-2xl p-6 border border-blue-200">
//           <h2 className="text-2xl font-bold text-center text-blue-600 mb-6">
//             Application Tracking Details
//           </h2>

//           {/* Application ID */}
//           <motion.div
//             initial={{ opacity: 0, scale: 0.9 }}
//             animate={{ opacity: 1, scale: 1 }}
//             className="bg-gradient-to-r from-blue-500 to-indigo-600 p-5 rounded-xl mb-6 shadow-lg text-white"
//           >
//             <p className="text-lg font-bold">Application ID</p>
//             <p className="text-2xl font-extrabold tracking-wider">
//               {application?.id}
//             </p>
//           </motion.div>

//           {/* Candidate Snapshot */}
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//             <div className="p-4 bg-gray-50 shadow rounded-lg">
//               <h3 className="text-lg font-semibold text-blue-500 mb-2">
//                 Personal Information
//               </h3>
//               <p>
//                 <strong>Name:</strong>{" "}
//                 {application?.candidateSnapshot?.firstName}{" "}
//                 {application?.candidateSnapshot?.lastName}
//               </p>
//               <p>
//                 <strong>Email:</strong>{" "}
//                 {maskEmail(application?.candidateSnapshot?.email)}
//               </p>
//               <p>
//                 <strong>Phone:</strong>{" "}
//                 {maskPhone(application?.candidateSnapshot?.phone)}
//               </p>
//             </div>

//             <div className="p-4 bg-gray-50 shadow rounded-lg">
//               <h3 className="text-lg font-semibold text-blue-500 mb-2">
//                 Position & Department
//               </h3>
//               <p>
//                 <strong>Position:</strong> {application?.positionTitle}
//               </p>
//               <p>
//                 <strong>Department:</strong> {application?.department}
//               </p>
//             </div>
//           </div>

//           {/* Status */}
//           <div className="p-4 mt-6 bg-gray-50 shadow rounded-lg">
//             <h3 className="text-lg font-semibold text-blue-500 mb-2">
//               Current Status
//             </h3>
//             <motion.p
//               className="text-xl font-semibold capitalize text-green-600"
//               initial={{ opacity: 0 }}
//               animate={{ opacity: 1 }}
//             >
//               {application?.applicationStatus}
//             </motion.p>
//           </div>
//         </div>
//       </motion.div>
//     </div>
//   );
// };

// export default TrackingDetails;
import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import { motion } from "framer-motion";
import { apiurl } from "../config/config";
import Header from "../components/header";
import {
  AlertCircle,
  User,
  Briefcase,
  FileText,
  Calendar,
  Award,
  ClipboardList,
  CheckCircle2,
  Clock,
} from "lucide-react";

const maskEmail = (email) => {
  if (!email) return "";
  const [name, domain] = email.split("@");
  return name.slice(0, 3) + "****@" + domain;
};

const maskPhone = (phone) => {
  if (!phone) return "";
  return "******" + phone.slice(-4);
};

const StatusBadge = ({ status }) => {
  let color =
    status === "completed" || status === "pass" || status === "joined" || status === "present"
      ? "bg-green-100 text-green-700"
      : status === "locked"
      ? "bg-gray-100 text-gray-700"
      : status === "in-progress"
      ? "bg-yellow-100 text-yellow-700"
      : "bg-red-100 text-red-700";

  return (
    <span className={`px-3 py-1 rounded-full text-xs font-medium ${color}`}>
      {status}
    </span>
  );
};

const TrackingDetails = () => {
  const [searchParams] = useSearchParams();
  const applicationId = searchParams.get("applicationid");
  const [application, setApplication] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (applicationId) {
      fetchApplicationDetails(applicationId);
    }
  }, [applicationId]);

  const fetchApplicationDetails = async (id) => {
    try {
      const response = await axios.get(`${apiurl}/api/application/get/id/${id}`);
      if (response.data.success) {
        setApplication(response.data.application);
      } else {
        setError(response.data.message || "Candidate not found");
      }
    } catch (err) {
      setError("Failed to fetch application details. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  console.log("application",application);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100 text-gray-700 text-lg">
        Loading...
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 px-6 py-10">
        <motion.div
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.4 }}
          className="bg-white p-6 rounded-2xl shadow-lg w-full max-w-md text-center border border-red-200"
        >
          <div className="flex justify-center mb-4">
            <div className="bg-red-100 p-4 rounded-full">
              <AlertCircle className="w-10 h-10 text-red-500" />
            </div>
          </div>
          <h2 className="text-xl font-bold text-red-600 mb-2">
            Candidate Not Found
          </h2>
          <p className="text-gray-600 text-sm mb-4">
            We couldn’t locate an application with ID:{" "}
            <span className="font-semibold">{applicationId}</span>
          </p>
          <button
            onClick={() => (window.location.href = "/")}
            className="mt-2 w-full py-2 px-4 bg-red-500 hover:bg-red-600 text-white rounded-lg font-medium transition"
          >
            Go Back Home
          </button>
        </motion.div>
      </div>
    );
  }

  return (
    <div>
      <Header />
      <motion.div
        className="min-h-screen px-3 py-6 bg-gray-50"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <div className="max-w-5xl mx-auto bg-white shadow-xl rounded-2xl p-6 border border-blue-200">
          {/* Title */}
          <h2 className="text-3xl font-bold text-center text-blue-600 mb-6">
            Candidate Application Details
          </h2>

          {/* Application ID */}
          <div className="bg-gradient-to-r from-blue-500 to-indigo-600 p-5 rounded-xl mb-6 shadow-lg text-white text-center">
            <p className="text-lg font-bold">Application ID</p>
            <p className="text-2xl font-extrabold tracking-wider">
              {application?.id}
            </p>
          </div>

          {/* Personal Information */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
            <div className="p-5 bg-gray-50 shadow rounded-xl">
              <h3 className="flex items-center gap-2 text-lg font-semibold text-blue-500 mb-2">
                <User className="w-5 h-5" /> Personal Information
              </h3>
              <p><strong>Name:</strong> {application?.candidateSnapshot?.firstName} {application?.candidateSnapshot?.lastName}</p>
              <p><strong>Email:</strong> {maskEmail(application?.candidateSnapshot?.email)}</p>
              <p><strong>Phone:</strong> {maskPhone(application?.candidateSnapshot?.phone)}</p>
              {/* <p><strong>DOB:</strong> {application?.candidateSnapshot?.dateOfBirth}</p> */}
              <p><strong>Gender:</strong> {application?.candidateSnapshot?.gender}</p>
            </div>

            <div className="p-5 bg-gray-50 shadow rounded-xl">
              <h3 className="flex items-center gap-2 text-lg font-semibold text-blue-500 mb-2">
                <Briefcase className="w-5 h-5" /> Position & Department
              </h3>
              <p><strong>Position:</strong> {application?.positionTitle}</p>
              <p><strong>Department:</strong> {application?.department}</p>
              <p><strong>Status:</strong> <StatusBadge status={application?.applicationStatus} /></p>
              <p><strong>Joining Date:</strong> {application?.offerDetails?.joiningDate?.split("T")[0]}</p>
              {/* <p><strong>CTC:</strong> {application?.offerDetails?.offeredCTC} LPA</p> */}
            </div>
          </div>

          {/* Screening & Induction */}
          {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
            <div className="p-5 bg-gray-50 shadow rounded-xl">
              <h3 className="flex items-center gap-2 text-lg font-semibold text-blue-500 mb-2">
                <ClipboardList className="w-5 h-5" /> Screening
              </h3>
              <p><strong>Screener:</strong> {application?.screeningDetails?.screenerName}</p>
              <p><strong>Feedback:</strong> {application?.screeningDetails?.feedback}</p>
              <p><strong>Status:</strong> <StatusBadge status={application?.screeningDetails?.status} /></p>
            </div>

            <div className="p-5 bg-gray-50 shadow rounded-xl">
              <h3 className="flex items-center gap-2 text-lg font-semibold text-blue-500 mb-2">
                <Award className="w-5 h-5" /> Induction
              </h3>
              <p><strong>Status:</strong> <StatusBadge status={application?.inductionDetails?.inductionStatus} /></p>
              <p><strong>Completed At:</strong> {application?.inductionDetails?.inductionCompletedAt?.split("T")[0]}</p>
            </div>
          </div> */}

          {/* Training */}
          {/* <div className="p-5 bg-gray-50 shadow rounded-xl mb-6">
            <h3 className="flex items-center gap-2 text-lg font-semibold text-blue-500 mb-2">
              <CheckCircle2 className="w-5 h-5" /> Training
            </h3>
            <p><strong>Trainer:</strong> {application?.trainingDetails?.trainerName}</p>
            <p><strong>Status:</strong> <StatusBadge status={application?.trainingDetails?.status} /></p>
          </div> */}

          {/* Attendance */}
{/* Attendance */}
{application?.attendance?.length > 0 && (
  <div className="p-5 bg-gray-50 shadow rounded-xl mb-6">
    <h3 className="flex items-center gap-2 text-lg font-semibold text-blue-500 mb-2">
      <Calendar className="w-5 h-5" /> Attendance
    </h3>
    <ul className="space-y-2">
      {application.attendance.map((att, idx) => (
        <li key={idx} className="flex items-center gap-3 text-sm">
          <Clock className="w-4 h-4 text-blue-500" />
          {att.date.split("T")[0]} – <StatusBadge status={att.status} />
        </li>
      ))}
    </ul>
  </div>
)}


          {/* Documents */}
          {/* <div className="p-5 bg-gray-50 shadow rounded-xl">
            <h3 className="flex items-center gap-2 text-lg font-semibold text-blue-500 mb-2">
              <FileText className="w-5 h-5" /> Documents
            </h3>
            <p><strong>Resume:</strong>{" "}
              {application?.documents?.resume?.uploaded ? (
                <a href={application?.documents?.resume?.link} target="_blank" rel="noreferrer" className="text-blue-600 underline">
                  View Resume
                </a>
              ) : "Not Uploaded"}
            </p>
            <p><strong>Photo:</strong> {application?.documents?.photo?.uploaded ? "Uploaded" : "Not Uploaded"}</p>
            <p><strong>Aadhar:</strong> {application?.documents?.aadharCard?.uploaded ? "Uploaded" : "Not Uploaded"}</p>
          </div> */}
        </div>
      </motion.div>
    </div>
  );
};

export default TrackingDetails;
